import * as API from './../base/api_service';
import * as serviceCallConfig from './../config/api_urls';

export var DASHBOARD_DETAILS = 'DASHBOARD_DETAILS';
export var DASHBOARD_DATA = 'DASHBOARD_DATA';
export var DASHBOARD_DETAILS_FAIL = 'FORGOT_PASSWORD_FAIL';

export var NOTIFICATIONS_DETAILS = 'NOTIFICATIONS_DETAILS';
export var NOTIFICATIONS_DATA = 'NOTIFICATIONS_DATA';
export var NOTIFICATIONS_DETAILS_FAIL = 'NOTIFICATIONS_DETAILS_FAIL';





export var dashboardCounts = (data) => {

    return (dispatch, getState) => {
         API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.DASHBOARD_DETAILS),//endPoint
            '',//payLoad
            serviceCallConfig.DASHBOARD_DETAILS,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};

export var dashboardData = (data) => ({
    type: DASHBOARD_DATA,
    data: data
});

export var dashboardDetailsFail = (data) => {
    return ({
        type: DASHBOARD_DETAILS_FAIL,
        data: data
    });
};

export var notifications = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
          serviceCallConfig.API_GET,//reqType
          dispatch,//dispatch
          serviceCallConfig.get(serviceCallConfig.NOTIFICATIONS_DETAILS),//endPoint
          '',//payLoad
          serviceCallConfig.NOTIFICATIONS_DETAILS,//requestFrom
          false,//isURLEncoded
          getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
          "",//api_key
          data,//getParams
          false,//multipart
          getState().User.loginData.data.uniqueKey, //uniqueKey
      );
    };
};

export var notificationsData = (data) => ({
    type: NOTIFICATIONS_DATA,
    data: data
});

export var nofificationDetailsFail = (data) => {
    return ({
        type: NOTIFICATIONS_DETAILS_FAIL,
        data: data
    });
};




export var ACTIVE_FACILITY = 'ACTIVE_FACILITY';
export var active_facilty_data = (data) => ({
    type: ACTIVE_FACILITY,
    data: data
});
export var get_active_facilty_data = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.ACTIVE_FACILITY),//endPoint
            '',//payLoad
            serviceCallConfig.ACTIVE_FACILITY,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};



/** WEBPACK FOOTER **
 ** ./src/actions/dashboard_actions.js
 **/